module.exports = __webpack_public_path__ + "static/media/choon_title.f057aee8.png";